import { Component } from '@angular/core';
import { PaCounterComponent } from 'src/app/shared/ui-kit/pa-counter/pa-counter.component';

@Component({
  selector: 'app-counter-view',
  standalone: true,
  imports: [PaCounterComponent],
  templateUrl: './counter-view.component.html',
  styleUrls: ['./counter-view.component.scss'],
})
export class CounterViewComponent {

  constructor() { }
}
